import { lazy } from "react";

export { CAREER_VACANCY_PATH } from "./path";
export const CareerVacancyPage = lazy(() => import("./page"));
